import { isMaskedPhoneCountry } from '@Constants';

function emailValidation(target: string) {
  const validTestCase = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return validTestCase.test(target);
}

function microchipValidation(target: string) {
  const validLengths = [9, 10, 15];

  return validLengths.includes(target.length);
}

/*
 * NOTE
 * US/CA keep the masked rule (9+ digits). Every other country is free text, so only the digit count
 * is checked: 7 to 15 — 15 is the E.164 cap, and 9 would reject 8-digit national numbers.
 * `country` is for a form about ANOTHER shelter (admin create shelter); omitted, the active shelter's
 * country applies.
 * */
function phoneValidation(input: string | Event, country?: string | null): boolean {
  const target = getPhoneTarget(input);
  const numericTarget = target.replace(/\D/g, '');

  if (!isMaskedPhoneCountry(country)) {
    const isValidLength = numericTarget.length >= 7 && numericTarget.length <= 15;

    return isValidLength;
  }

  if (numericTarget.length < 9) return false;

  const validPattern = /^(\d ?)?\(?\d{3}\)? \d{3}-\d{4}$/;
  return validPattern.test(target) || numericTarget.length >= 9;
}

function getPhoneTarget(target: string | Event): string {
  const isEventOrElement = target instanceof Event && target.target && target.target instanceof HTMLInputElement;

  return isEventOrElement ? target.target.value : String(target);
}

function animalNameValidation(target: string): boolean {
  return !/[/\\+]/.test(target);
}

function urlValidation(target: string): boolean {
  const trimmedTarget = target.trim();
  if (!trimmedTarget) return false;

  const validPattern = /^(https?:\/\/)?([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(\/.*)?$/;

  return validPattern.test(trimmedTarget);
}

export { animalNameValidation, emailValidation, microchipValidation, phoneValidation, urlValidation };
